import React, { useState, useEffect } from "react";
import CardActivity from '../../components/CardActivity'
import HeaderText from '../../components/HeaderText'
import ActiveActivity from '../../components/ActiveActivity'
import { Button, Row, Col } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import { Redirect } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { Doughnut } from "react-chartjs-2";
import $, { data } from 'jquery'
import UserService from "../../controllers/UserService";
import WelcomeDialog from "../../components/login/WelcomeDialog";

const Activity = props => {

    const [roomName, setRoomName] = useState([]);

    const [strengths, setStrengths] = useState([]);
    const [allPercent, setSetPercent] = useState([]);
    const [key, setSetKey] = useState([]);
    const [selfText, setSelfText] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [maxValue, setMaxValue] = useState(0);
    const [studentName, setStudentName] = useState('');
    const [hasOnlineActivity, setHasOnlineActivity] = useState(false);
    const [roomId, setRoomId] = useState('');

    let newStrengths = [];
    let color = {

        "brave": "#FFCECE",
        "honesty": "#FF9B9B",
        "perseverance": "#E04E4E",
        "zest": "#B41616",
        "fairness": "#A1AEF9",
        "citizenship": "#465BCC",
        "leadership": "#1A2979",
        "humility": "#FFD2F5",
        "forgiveness": '#FFA1E9',
        "self_regulation": "#D761BB",
        "prudence": "#801967",
        "hope": "#FFDEC8",
        "spirituality": "#FFC096",
        "beauty_excellence": "#EA833D",
        "humor": "#E46C1A",
        "gratitude": '#923806',
        "creativity": "#CDFFF6",
        "curiosity": '#8FFFEA',
        "judgement": "#67D2BE",
        "love_of_learning": "#2FA992",
        'perspective': '#147B68',
        "kindness": "#D8F4FF",
        "social": "#96DAF5",
        "love": "#2893BD",
    };


    useEffect(() => {
        const data = AuthService.getCurrentUser();
        const userRole = AuthService.getUserRole();
        const rName = (data.room && data.room.displayName) ? data.room.displayName : '';
        const rRoomId = (data.room && data.room.id) ? data.room.id : ''
        setRoomName(rName);
        setRoomId(rRoomId);

        try {
            var user = AuthService.getCurrentUser();
            setStudentName(user.fullName);
            UserService.getRoomDetail(rRoomId).then((response) => {
                return {
                    "domain": user.domain.name,
                    "roomId": roomId,
                    "year": response.data.data.year,
                    "term": response.data.data.term,
                };

            }).then(() => {
                if (userRole === 'student') {
                    UserService.getActivities({
                        'status': 'RUNNING',
                        'roomId': rRoomId,
                        'domain': AuthService.getCurrentUser() && AuthService.getCurrentUser().domain ? AuthService.getCurrentUser().domain.name : ''
                    }).then((res) => {
                        setHasOnlineActivity(res.data.total)
                    });
                }
            });
        } catch (error) {

        }

    }, [])




    if (AuthService.getCurrentUser() && AuthService.getUserRole() === 'headmaster') {
        return <Redirect to='/report' />
    }

    const handleCardActivityBackground = (v) => {
        props.onChange(v)
    }
    return (
        <div>
            <Helmet>
                <title>กิจกรรมปรับใจในห้องเรียน จิตวิทยาเชิงบวกเริ่มต้นได้ที่นี่ - Mindsetmaker.co</title>
                <meta property="og:title" content="กิจกรรมปรับใจในห้องเรียน จิตวิทยาเชิงบวกเริ่มต้นได้ที่นี่ - Mindsetmaker.co" />
                <meta property="og:description" content="กิจกรรมการเรียนรู้จิตวิทยาเชิงบวกในห้องเรียน ด้วยเครื่องมือปรับใจ" />
            </Helmet>
            <Row className="bg-lightness2-blue">
                <Col className="main-detail header-text">
                    <HeaderText text1={`ปรับใจ ห้อง ${roomName}`} />
                </Col>
            </Row>
            <Row className="bg-lightness2-blue">
                <Col className="main-detail">
                    <ActiveActivity onChange={value => handleCardActivityBackground(value)} />
                </Col>
            </Row>
            <Row className={(AuthService.getUserRole() === 'student' && hasOnlineActivity) ? `bg-lightness3-blue py-3` : `bg-lightness2-blue py-3`}>
                <Col className="text-center main-detail my-3">
                    <CardActivity action="activity" btnText="-" />
                </Col>
            </Row>
            <WelcomeDialog />
        </div>
    );
};

export default Activity;